$shm_projects_goal_request $mol_view
	label \
	value? \
	attachments? /$shm_projects_goal_attachment
	attachments_payload /$shm_projects_goal_attachment
	after /
	requirements false
	refinement false
	drag_active? false
	sub <= request_content /
	Field $mol_form_field
		name <= label \
		attr *
			^
			shm_projects_goal_requirements <= requirements false
			shm_projects_goal_refinement <= refinement false
		Content <= Input $mol_textarea
			value? <=> value?
			event *
				^
				paste? <=> image_paste? null
	Attachments $mol_list
		rows <= attachment_rows /
	attr *
		^
		shm_projects_goal_request_drag <= drag_active false
	event *
		^
		dragenter? <=> drag_enter? null
		dragover? <=> drag_over? null
		dragleave? <=> drag_leave? null
		drop? <=> file_drop? null
	Attachment* $mol_view
		sub /
			<= Attachment_image* $mol_image
				uri <= attachment_uri* \
			<= Attachment_name* $mol_text
				text <= attachment_name* \
			<= Attachment_remove* $mol_button_minor
				title \Удалить изображение
				sub /
					<= Attachment_remove_icon* $mol_icon_close
				click? <=> attachment_remove*? null
